module.exports = [{
      plugin: require('/tmp/4b834f0a/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-47602535-3"},
    },{
      plugin: require('/tmp/4b834f0a/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
